import React from 'react';
import { SELECTABLE_PLANS, TONE_CLASSES } from '../../../lib/shopBilling';

/**
 * Bloque de facturación de una tienda — plan, aviso del paso pendiente y la acción.
 *
 * Único sitio donde vive: antes estaba duplicado en la tarjeta, en la lista móvil
 * de la tabla y en la tabla de escritorio. `Cancelar suscripción` ya no vive aquí:
 * es destructiva y se ha movido al menú «⋯» junto a `Eliminar tienda`.
 */
export default function ShopBillingBlock({
  billing,
  selectedPlan,
  onSelectPlan,
  onAction,
  compact = false,
}) {
  const { planLabel, canPickPlan, nextStep, primaryAction, state } = billing;

  return (
    <div className={`rounded-lg bg-gray-50 ${compact ? 'p-3' : 'p-3'} space-y-2`}>
      <div className="flex items-center justify-between gap-2">
        <span className="text-xs text-gray-500">
          {canPickPlan ? 'Plan para activar' : 'Plan contratado'}
        </span>
        {!canPickPlan && (
          <span className="text-sm font-medium text-gray-900">{planLabel}</span>
        )}
      </div>

      {canPickPlan && (
        <select
          aria-label="Plan para activar"
          value={selectedPlan}
          onChange={(e) => onSelectPlan(e.target.value)}
          className="w-full rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-900"
        >
          {SELECTABLE_PLANS.map((plan) => (
            <option key={plan.value} value={plan.value}>{plan.label}</option>
          ))}
        </select>
      )}

      {nextStep && (
        <p
          className={`rounded-md border px-2.5 py-2 text-xs leading-5 ${
            state === 'past_due' ? TONE_CLASSES.warning : 'border-gray-200 bg-white text-gray-600'
          }`}
        >
          {nextStep}
        </p>
      )}

      <button
        type="button"
        onClick={() => onAction(primaryAction.kind, selectedPlan)}
        className={
          primaryAction.kind === 'portal'
            ? 'w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-800 transition-colors hover:bg-gray-50'
            : 'w-full rounded-lg bg-emerald-500 px-3 py-2 text-sm font-semibold text-white transition-colors hover:bg-emerald-600'
        }
      >
        {primaryAction.label}
      </button>
    </div>
  );
}
